import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantCashTransferServiceService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetCashTransferStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cashTransferStatus = useQuery(
    ['getCashTransferStatus'],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return cashTransferStatus;
};

export default useGetCashTransferStatus;
